const PDF_EXTENSION = "pdf";
const WORD_EXTENSION = "word";
const DOCX_EXTENSION = "docx";
const XLSX_EXTENSION = "xlsx";
const XLS_EXTENSION = "xls";

export {
    PDF_EXTENSION, WORD_EXTENSION, XLSX_EXTENSION,
    XLS_EXTENSION, DOCX_EXTENSION
}